import { setCookie } from "../utils/cookies";
import PagesService from "../api/services/pagesService";

export async function checkCustomRouteAccess(route, page) {
  if (!page.has_password) {
    if (page.password) {
      setCookie(route, page.password);
    }

    return page;
  }

  const password = prompt("Please Enter Password", "");
  page = await PagesService.get(route, password);

  if (page.has_password) {
    alert("Invalid password!");
    page = await checkCustomRouteAccess(route, page);
  }

  setCookie(route, page.password);

  return page;
}
